import { colors } from '@aloft/toolkit-sui';
import { Appearance } from '@stripe/stripe-js';

export const elementsAppearance: Appearance = {
  variables: {
    fontFamily: 'Lato, Helvetica, Arial, sans-serif',
    borderRadius: '4px',
  },
  rules: {
    '.Label': {
      color: colors.textPrimary,
      fontSize: '1rem', // variant="label"
    },
    '.Input': {
      color: colors.textPrimary,
      marginBottom: '0.5rem', // adds some breathing room
      borderColor: colors.strokeDefault,
      boxShadow: 'initial',
    },
    '.TermsText': {
      paddingBottom: '0.75rem',
      color: colors.textTertiary,
      fontSize: '0.75rem', // variant="body2"
      fontWeight: '400', // variant="body2"
    },
    // the following states are styled to match <SimpleInput>
    '.Input:hover': {
      borderColor: colors.hover2,
    },
    '.Input:focus': {
      borderColor: colors.selected2,
      boxShadow: `inset 0 0 0 1px ${colors.selected2}`,
      outline: 'none',
    },
    '.Input--invalid': {
      borderColor: colors.alertError,
    },
    '.Input--invalid:hover': {
      borderColor: colors.alertError,
    },
    '.Input--invalid:focus': {
      borderColor: colors.alertError,
      boxShadow: `inset 0 0 0 1px ${colors.alertError}`,
    },
  },
};
